import _ from "underscore";

import React from 'react';
import createReactClass from 'create-react-class';
import BaseMixin from './BaseMixin';
import Styles from './../StyleSheet';
import PropTypes from "prop-types";

const PhoneType = createReactClass({
  propTypes: {
    node: PropTypes.object,
    editable: PropTypes.bool
  },
  displayName: 'PhoneType',
  mixins: [BaseMixin],

  render: function() {
    return (
      <div className="form-inline">
        {this.renderTerminalName()}
        <select
          className="form-control"
          style={this._selectStyles()}
          value={this.props.node.get('terminal')}
          onChange={this._onTypeChange}
          disabled={!this.props.editable}
        >
          <option value="mobile">Mobile</option>
          <option value="landline">Landline</option>
        </select>
      </div>
    );
  },

  _onTypeChange: function(evt) {
    this.props.node.set('terminal', evt.target.value);
  },

  _selectStyles: function() {
    return (
      _.extend(
        {},
        Styles.select,
        Styles.lastChild
      )
    );
  }
});

export default PhoneType;
